import DashboardVesselTrafficInformation from './dashboard-vessel-traffic-information.container'

export default DashboardVesselTrafficInformation